import styled from "styled-components";

export const WrapperDate = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const DisplayDate = styled.p`
  margin: 0;
  font-size: 0.9em;
`